import { IAttrValue } from "@multiweb/types/contracts";
import { ItemTemplate } from "../ItemTemplate";

export class ColorTemplate extends ItemTemplate {
    public override async updateData(dataSet: IAttrValue[], item: HTMLElement): Promise<void> {
        item.innerHTML = "";
        item.classList.add("color");

        const data = this._getDataFromSet(dataSet);

        if (data) {
            item.style.backgroundColor = data.valueOf();
        } else {
            item.style.removeProperty("background-color");
        }
    }
}
